import { defineComponent as T, computed as N, createElementBlock as t, createCommentVNode as l, unref as e, openBlock as d, normalizeClass as O, withModifiers as g, createElementVNode as c, createVNode as y, withCtx as D, createTextVNode as b } from "vue";
import V from "github-slugger";
import v from "../../../../components/Badge/Badge.vue.js";
import { useConfig as j } from "../../../../hooks/useConfig.js";
import { downloadDocument as B } from "../../../../libs/download.js";
const $ = /* @__PURE__ */ T({
  __name: "DownloadLink",
  props: {
    title: {},
    getOriginalDocument: { type: Function }
  },
  setup(r) {
    const n = j(), k = new V(), x = N(() => k.slug(r.title ?? "")), u = (a) => {
      B(r.getOriginalDocument(), x.value, a);
    };
    return (a, o) => {
      var i, m, s, p, w, f;
      return ((i = e(n)) == null ? void 0 : i.documentDownloadType) !== "none" ? (d(), t("div", {
        key: 0,
        class: O(["download-container group", {
          "download-both": ((m = e(n)) == null ? void 0 : m.documentDownloadType) === "both"
        }])
      }, [
        ((s = e(n)) == null ? void 0 : s.documentDownloadType) === "json" || ((p = e(n)) == null ? void 0 : p.documentDownloadType) === "both" ? (d(), t("button", {
          key: 0,
          class: "download-button",
          type: "button",
          variant: "ghost",
          onClick: o[0] || (o[0] = g((C) => u("json"), ["prevent"]))
        }, [
          o[3] || (o[3] = c("span", null, " Download OpenAPI Document ", -1)),
          y(v, { class: "extension hidden group-hover:flex" }, {
            default: D(() => o[2] || (o[2] = [
              b("json")
            ])),
            _: 1,
            __: [2]
          })
        ])) : l("", !0),
        ((w = e(n)) == null ? void 0 : w.documentDownloadType) === "yaml" || ((f = e(n)) == null ? void 0 : f.documentDownloadType) === "both" ? (d(), t("button", {
          key: 1,
          class: "download-button",
          type: "button",
          variant: "ghost",
          onClick: o[1] || (o[1] = g((C) => u("yaml"), ["prevent"]))
        }, [
          o[5] || (o[5] = c("span", null, " Download OpenAPI Document ", -1)),
          y(v, { class: "extension hidden group-hover:flex" }, {
            default: D(() => o[4] || (o[4] = [
              b("yaml")
            ])),
            _: 1,
            __: [4]
          })
        ])) : l("", !0)
      ], 2)) : l("", !0);
    };
  }
});
export {
  $ as default
};
